import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, asyncScheduler, of, scheduled } from 'rxjs';
import { map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { Config, ConfigBase } from '../../model/config/config.model';
import { EntityBase } from '../../model/entity/entity.model';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {

	protected resourceUrl: string = "/rest/security/config"

	e2URL: string = "";

	config: Config = new ConfigBase()

	constructor(private http: HttpClient, private location: Location) { }

	// Initial loggin method, executed on app.module.ts on initial providers //
	public initLoggin(): Promise<void> {
		return this.init().toPromise().then(
			(r) => { }
		).catch(
			(r) => {
				console.error("Error logging: ", r)
			}
		)
	}

	init(): Observable<Config> {
		if (this.config.hasConnectedUser()) {
			return scheduled(of(this.config), asyncScheduler)
		}

		return this.http.get<Config>(`${this.resourceUrl}/init`).pipe(map(result => {
			this.config = ConfigBase.fromConfig(result)
			return this.config
		}))
	}

	getConnectedEntity(): EntityBase {
		return this.config.connectedEntityDetail.entity
	}

	permisos(): Observable<string> {
		return this.http.get<string>(`${this.resourceUrl}/permisosqwd`).pipe(map(result => {
			return result
		}))
	}

}
